import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { checkUserPermission } from "../../../common/UserPermission";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useMemo } from "react";

function PaymentLog() {
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");

  const [formValues, setFormValues] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(25);
  const [searchtext, setSearchText] = useState("");
  const [sortingId, setSortingId] = useState(1); //currentorder
  const [sortingDirection, setSortingDirection] = useState("desc"); // ordercolumn

  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState([]);
  const [selectSupplier, setSelectSupplier] = useState(0);
  const [customer, setCustomer] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(0);
  const [transactionTypeDropdown, setTransactionTypeDropdown] = useState([]);
  const [selectTransaction, setSelectTransaction] = useState(1);

  const [beginningDate, setBeginningDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [customeDate, setCustomDate] = useState(0);

  const [showSupplierSelect, setShowSupplierSelect] = useState(true);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const navigate = useNavigate();

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const dateOptions = [
    { label: "Select", value: 0 },
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
  ];

  // const columns = [
  //   {
  //     name: "ACTION",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group" >
  //           {row?.Module === "SALES" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-sales/${row.ID}`}

  //             >
  //               Edit
  //             </Link>
  //           ) : row?.Module === "RECEIVINGS" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-receiving/${row.ID}`}
  //             >
  //               Edit
  //             </Link>
  //           ) : row?.Module === "DEPOSIT" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/bank-deposit/${row.ID}`}
  //             >
  //               Edit
  //             </Link>
  //           ) : row?.Module === "TRANSFER" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-transfer/${row.ID}`}
  //             >
  //               Edit
  //             </Link>
  //           ) : row?.Module === "JOURNAL" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/journal-entry/${row.ID}`}
  //             >
  //               Edit
  //             </Link>
  //           ) : row?.Module === "PAYBILLS" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/receiving-paybills/${row.ID}`}
  //             >
  //               Edit
  //             </Link>
  //           ) : row?.Module === "RECEIVEPAYMENT" ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/receive-payment/${row.ID}`}
  //             >
  //               Edit
  //             </Link>
  //           ) :
  //             (
  //               ""
  //             )}
  //           {/* <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button> */}
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     //width: "7%",//"100px",
  //     minWidth: "70px",
  //     width: "70px",
  //   },
  //   {
  //     name: "DATE",
  //     selector: (row) => {
  //       return row?.Date == null
  //         ? ""
  //         : moment(row["Date"]).format('DD-MM-YYYY');
  //     },
  //     sortable: true,
  //     width: "110px",
  //   },
  //   {
  //     name: "TYPE",
  //     // selector: (row) => row["Type"],
  //     selector: (row) => (
  //       <div className="word-break-data">
  //         {row.Type}
  //       </div>
  //     ),
  //     sortable: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "NO.",
  //     selector: (row) => row["No"],
  //     sortable: true,
  //     width: "110px",
  //   },
  //   {
  //     name: "CONTACT",
  //     selector: (row) => row["Contact"],
  //     sortable: true,
  //     // width: "150px",
  //     cell: (row) => (
  //       <>
  //         {row?.IsSupplier === 1 && row?.SupCusId !== null ? (
  //           <Link to={`/manage-suppliers/${row?.SupCusId}`}>
  //             {row?.Contact}
  //           </Link>
  //         ) : row?.IsSupplier === 2 && row?.SupCusId !== null ? (
  //           <Link to={`/manage-customers/${row?.SupCusId}`}>
  //             {row?.Contact}
  //           </Link>
  //         ) : (
  //           <div>{row?.Contact}</div>
  //         )}
  //       </>
  //     ),
  //   },
  //   {
  //     name: "MEMO/DESC.",
  //     // selector: (row) => row["Memo"],
  //     selector: (row) => (
  //       <div className="word-break-data">
  //         {row.Memo}
  //       </div>
  //     ),
  //     sortable: true,
  //     width: "136px",
  //   },
  //   {
  //     name: "DUE DATE",
  //     selector: (row) => {
  //       return row?.DueDate == null
  //         ? ""
  //         : moment(row["DueDate"]).format('DD-MM-YYYY');
  //     },
  //     sortable: true,
  //     width: "115px",
  //   },
  //   {
  //     name: "AMOUNT",
  //     selector: (row) => parseFloat(row["Amount"]).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     width: "110px",
  //   },
  //   {
  //     name: "MODIFIED",
  //     selector: (row) => {
  //       return row?.LastModifiedDate == null
  //         ? ""
  //         : moment(row["LastModifiedDate"]).format('DD-MM-YYYY');
  //     },
  //     center: true,
  //     sortable: true,
  //     width: "115px",
  //   },
  //   // {
  //   //   name: "ACTION",
  //   //   width: "100px",
  //   //   center: true,
  //   //   cell: (row) => (
  //   //     <>
  //   //       {row?.Module === "SALES" ? (
  //   //         <Link to={`/manage-sales/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : row?.Module === "RECEIVINGS" ? (
  //   //         <Link to={`/manage-receiving/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : row?.Module === "DEPOSIT" ? (
  //   //         <Link to={`/bank-deposit/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : row?.Module === "TRANSFER" ? (
  //   //         <Link to={`/manage-transfer/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : row?.Module === "JOURNAL" ? (
  //   //         <Link to={`/journal-entry/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : row?.Module === "PAYBILLS" ? (
  //   //         <Link to={`/receiving-paybills/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : row?.Module === "RECEIVEPAYMENT" ? (
  //   //         <Link to={`/receive-payment/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) :
  //   //         (
  //   //           ""
  //   //         )}
  //   //     </>
  //   //   ),
  //   // },
  // ];

  const columns = useMemo(() => [
    {
      header: "DATE",
      accessorKey: "Date",
      Cell: ({ row }) =>
        row.original.Date == "0000-00-00" ||
        row.original.Date == "" ||
        row.original.Date == null
          ? ""
          : moment(row.original.Date).format("DD-MM-YYYY"),
    },

    {
      header: "TYPE",
      accessorKey: "Type",
    },
    {
      header: "NO.",
      accessorKey: "No",
    },
    {
      header: "Created On",
      accessorKey: "CreatedOn",
      Cell: ({ row }) =>
        moment(row.original.CreatedOn).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      header: "CONTACT",
      accessorKey: "Contact",
      Cell: ({ row }) => (
        <>
          {row?.original.IsSupplier === 1 && row?.original.SupCusId !== null ? (
            <Link to={`/manage-suppliers/${row?.original.SupCusId}`}>
              {row?.original.Contact}
            </Link>
          ) : row?.original.IsSupplier === 2 &&
            row?.original.SupCusId !== null ? (
            <Link to={`/manage-customers/${row?.original.SupCusId}`}>
              {row?.original.Contact}
            </Link>
          ) : (
            <div>{row?.original.Contact}</div>
          )}
        </>
      ),
    },
    {
      header: "MEMO/DESC.",
      accessorKey: "Memo",
    },
    {
      header: "DUE DATE",
      accessorKey: "Memo",
      Cell: ({ row }) => {
        return row?.original?.DueDate == null ||
          row?.original?.DueDate == "0000-00-00" ||
          row?.original?.DueDate == ""
          ? ""
          : moment(row?.original?.DueDate).format("DD-MM-YYYY");
      },
    },
    {
      header: "AMOUNT",
      accessorKey: "Amount",
      Cell: ({ row }) => {
        return parseFloat(row?.original?.Amount).toFixed(2);
      },
    },
    {
      header: "MODIFIED",
      accessorKey: "Memo",
      Cell: ({ row }) => {
        return row?.original?.LastModifiedDate == null
          ? ""
          : moment(row?.original?.LastModifiedDate).format("DD-MM-YYYY");
      },
    },
  ]);

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  //Date

  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  // Option Set Date
  const handleDateFilter = (event) => {
    console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    }
  };

  //starting Date
  const handleDate = (event) => {
    // console.log(beginningDate, "From:")
    console.log(event?.target?.value, "eventisss92");
    setBeginningDate(event?.target?.value);
    setCustomDate(7);
  };

  //End Date
  const handleEndDate = (event) => {
    setFinalDate(event?.target?.value);
    setCustomDate(7);
  };

  useEffect(() => {
    SupplierAPI();
    CustomerAPI();
    transactionType();
  }, []);

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      sortingId, //currentorder
      sortingDirection, //ordercolumn,
      searchtext,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [
    selectTransaction,
    beginningDate,
    finalDate,
    selectCustomer,
    selectSupplier,
    searchtext, //
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const SupplierAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        // setSupplier([
        //   { FirstName: "Select Supplier", ID: 0 },
        //   ...response.data.ResponseData,
        // ]);
        setSupplier(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CustomerAPI = () => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(true);
        setCustomer(res.data.ResponseData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const transactionType = () => {
    //payee Api
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setTransactionTypeDropdown(res.data.ResponseData);
        // console.log("res280", res.data.ResponseData);
      });
  };

  // const paymentDetailsAPI = () =>{

  // }

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      e.id, //currentorder
      sortingDirection, //ordercolumn,
      searchtext
    );
  };

  const handleListData = (
    pagenumber,
    pagesize,
    transactiontype,
    beginningDate,
    finalDate,
    customerid,
    supplierid,
    currentorder,
    ordercolumn,
    searchtext,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    beginningDate =
      beginningDate == undefined
        ? ""
        : beginningDate == null
        ? ""
        : beginningDate;
    finalDate =
      finalDate == undefined ? "" : finalDate == null ? "" : finalDate;

    setLoading(true);

    console.log("angel", columnFilters, globalFilter, pagination, sorting);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/transactionpaymentlog?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&transactiontype=${transactiontype}&supplierid=${supplierid}&customerid=${customerid}&locationid=${locationId}&startdate=${beginningDate}&enddate=${finalDate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res.data.ResponseData", res.data.ResponseData);
        // setData(res.data.ResponseData);
        // let newArray = res.data.ResponseData.map((obj) => {
        //   return { ...obj, Checked: false, PaymentMethod: 1 };
        // });
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setFormValues(res.data.ResponseData);
        setData(res.data.ResponseData);
        setLoading(false); // Set loading state to false after data is fetched
      })
      .catch((err) => {
        setLoading(false); // Set loading state to false in case of an error
      });
  };

  //Supplier Dropdown
  let supplierTypeDropdownOption = [];
  const termpsupplierlist = supplier.filter((u, i) => {
    supplierTypeDropdownOption[i] = {
      // label: u.FirstName,
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.ID,
    };
  });

  //Customer Dropdown
  let customerOption = [];
  const customerDropdown = customer.map((u, i) => {
    customerOption[i] = {
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.Id,
    };
  });

  //TransactionType Dropdown
  let transactionTypeDropdownOption = [];
  const transactionDropdown = transactionTypeDropdown?.map((u, i) => {
    transactionTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const selectTransactionHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectTransaction(event == undefined ? 1 : event);
  };

  const radioClickSupplierHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");

    setShowCustomerSelect(false);
    setShowSupplierSelect(true);
  };

  const radioClickCustomerHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");
    setShowSupplierSelect(false);
    setShowCustomerSelect(true);
  };

  const selectSupplierHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectSupplier(event == undefined ? 0 : event);
    setSelectCustomer(0);
  };

  const selectCustomerHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectCustomer(event == undefined ? 0 : event);
    setSelectSupplier(0);
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      sortingId, //currentorder
      sortingDirection, //ordercolumn
      searchtext
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      sortingId, //currentorder
      sortingDirection, //ordercolumn
      searchtext
    );
  };

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  console.log(data, "data==>");

  const downloadPDF = (rows, field) => {
    setLoading(true);

    let newData = [];
    if (field === "selectedRow") {
      newData = rows.map((row) => row.original);
    } else if (field === "allData") {
      newData = data;
    }

    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 37;

    for (var i = 1; i <= Math.ceil(newData.length / 37); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Date</th>' +
        '<th style="padding: 5px;">Type</th>' +
        '<th style="padding: 5px; text-align: right;">NO.</th>' +
        '<th style="padding: 5px;">Contact</th>' +
        '<th style="padding: 5px;">Memo/Desc</th>' +
        '<th style="padding: 5px; text-align: right;">Due Date</th>' +
        '<th style="padding: 5px; text-align: right;">Amount</th>' +
        '<th style="padding: 5px; text-align: right;">Last Modified Date</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].Date).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Type +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].No).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Contact +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(newData[index - 1].DueDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            moment(newData[index - 1].LastModifiedDate).format("DD-MM-YYYY") +
            "</td>" +
            "</tr>";
        }

        if (index % 37 == 0) {
          startIndex = startIndex + 37;
          endIndex = endIndex + 37;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("pdf.pdf");
        setLoading(false);
      },
    });
  };

  const onBtPrint = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 37;

    for (var i = 1; i <= Math.ceil(data.length / 37); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Date</th>' +
        '<th style="padding: 5px;">Type</th>' +
        '<th style="padding: 5px; text-align: right;">NO.</th>' +
        '<th style="padding: 5px;">Contact</th>' +
        '<th style="padding: 5px;">Memo/Desc</th>' +
        '<th style="padding: 5px; text-align: right;">Due Date</th>' +
        '<th style="padding: 5px; text-align: right;">Amount</th>' +
        '<th style="padding: 5px; text-align: right;">Last Modified Date</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= data.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].Date).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Type +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].No).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Contact +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].DueDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            moment(data[index - 1].LastModifiedDate).format("DD-MM-YYYY") +
            "</td>" +
            "</tr>";
        }

        if (index % 37 == 0) {
          startIndex = startIndex + 37;
          endIndex = endIndex + 37;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  const handleexcelexport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(formValues);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Transactionlog_details_.xlsx`);
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  console.log(data, "data1039");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          {/* Header Scetion */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Accounting: Transaction Log</h3>
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Payment Log</li>
              </ul>
            </div>

            {/* export Print arrange Columns */}
          </div>

          {/* <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "10px" }}>
            <button
              className="btn btn-sm btn-primary"
              onClick={handleexcelexport}
            >
              <i className="fas fa-file-excel me-2 lg"></i>
              Export Excel
            </button>
            <button className="btn btn-sm btn-primary" onClick={downloadPDF}>
              <i className="fas fa-file-export me-2 lg"></i>
              Export PDF
            </button>

            <button className="btn btn-sm btn-primary" onClick={onBtPrint}>
              <i className="fa fa-print me-2 lg"></i> Print PDF
            </button>

            <div>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa fa-cog me-2 lg"></i>
              </button>
              <div className="dropdown-menu">
                {columns.map((column) =>
                  // omit Action column
                  column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                    <div
                      key={column.name.replace(/\s+|-|\/|#/g, "")}
                      className="form-check ms-2 mt-1"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                        value={column.name.replace(/\s+|-|\/|#/g, "")}
                        checked={
                          !hiddenColumns.includes(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        } // check all checkboxes which are not include in hiddenColumns
                        onChange={() =>
                          handleCheckboxChange(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                      >
                        {column.name}
                      </label>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div>
          </div> */}

          {/* Filter Section */}
          <div className="card">
            <div className="card-body">
              {/* First Row */}
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexDirection: "column",
                }}
              >
                {/* 1st Filter */}
                <div
                  className="col-md-10"
                  style={{ display: "flex", gap: "1rem" }}
                >
                  {/* Date Filter */}
                  <div className=" col-md-2" style={{ width: "fit-content" }}>
                    Date:
                    <Select
                      onChange={(event) => {
                        handleDateFilter(event);
                      }}
                      options={dateOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      // hideSelectedOptions={true}
                      // styles={selectStyles}
                      value={dateOptions.find((el) => el?.value == customeDate)}
                      isOptionDisabled={(option) => option.value == 0}
                      className="custom-search-select"
                    />
                  </div>
                  {/* From Date */}
                  <div className="col-md-2">
                    From:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={beginningDate}
                      onChange={(event) => handleDate(event)}
                    />
                  </div>
                  {/* To Date */}
                  <div className="col-md-2">
                    To:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={finalDate}
                      onChange={(event) => handleEndDate(event)}
                    />
                  </div>
                </div>

                {/* 2nd Filter */}
                <div
                  className="col-md-10"
                  style={{ display: "flex", gap: "1rem", alignItems: "center" }}
                >
                  {/* Search Filter  */}
                  {/* <div className="col-md-2">
                    Search:
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search"
                      name="Search"
                      id="Search"
                      onChange={(event) =>
                        // handleChangeInput(event, "Search")
                        setSearchText(event.target.value)
                      }
                    ></input>
                  </div> */}
                  {/* Transaction Filter */}
                  <div className="col-md-3">
                    Transaction Type:
                    <Select
                      options={transactionTypeDropdownOption}
                      value={transactionTypeDropdownOption.find(
                        (option) => option?.value == selectTransaction
                      )}
                      onChange={(event) => {
                        selectTransactionHandle(event?.value);
                      }}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      hideSelectedOptions={true}
                      styles={selectStyles}
                      id="Transaction"
                      name="Transaction"
                      className="custom-search-select"
                    />
                  </div>

                  <div className="mt-4 col-md-1">
                    <input
                      type="radio"
                      onClick={(e) => radioClickSupplierHandle(e)}
                      checked={showSupplierSelect}
                      style={{ fontSize: "1rem" }}
                    />{" "}
                    Supplier
                  </div>

                  <div className="mt-4 col-md-1" style={{ width: "auto" }}>
                    <input
                      type="radio"
                      onClick={(e) => radioClickCustomerHandle(e)}
                      checked={showCustomerSelect}
                      style={{ fontSize: "1rem" }}
                    />{" "}
                    Customer
                  </div>

                  {/* Supplier Filter */}
                  {showSupplierSelect && (
                    <div className="col-md-4">
                      Supplier
                      <Select
                        options={supplierTypeDropdownOption}
                        value={supplierTypeDropdownOption.find(
                          (option) => option?.value == selectSupplier
                        )}
                        onChange={(event) => {
                          selectSupplierHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        // filterOption={customFilterOption}
                        styles={selectStyles}
                        id="Supplier"
                        name="Supplier"
                        className="custom-search-select"
                        // defaultInputValue="Select Supplier..."
                        // isOptionDisabled={(option) => option.value == 0}
                      />
                    </div>
                  )}

                  {/* Customer Filter */}
                  {showCustomerSelect && (
                    <div className="col-md-4">
                      Customer
                      <Select
                        options={customerOption}
                        value={customerOption.find(
                          (option) => option?.value == selectCustomer
                        )}
                        onChange={(event) => {
                          selectCustomerHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        // filterOption={customFilterOption}
                        styles={selectStyles}
                        id="Supplier"
                        name="Supplier"
                        className="custom-search-select"
                        // isOptionDisabled={(option) => option.value == 0}
                        // defaultInputValue="Select Customer..."
                      />
                    </div>
                  )}
                  {/* Search Filter */}
                  {/* <div className="col-md-2">
                    Search:
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search"
                      name="Search"
                      id="Search"
                      onChange={(event) =>
                        // handleChangeInput(event, "Search")
                        setSearchText(event.target.value)
                      }
                    ></input>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Data Table  */}
          <div className="card">
            <div className="card-body">
              <div
                style={{
                  margin: "10px",
                  display: "flex",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "16px",
                  }}
                >
                  <div>
                    Search:{" "}
                    {
                      transactionTypeDropdownOption.find(
                        (option) => option?.value == selectTransaction
                      )?.label
                    }
                  </div>
                  <div>
                    {formValues?.length > 0 ? (
                      <> Found {formValues[0]?.TotalRecord} matches.</>
                    ) : (
                      "No items found."
                    )}
                  </div>
                  <div>
                    {beginningDate && (
                      <>
                        From: {beginningDate}{" "}
                        {finalDate != "" && <>To: {finalDate}</>}{" "}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* data Table */}
              {/* <div className="table-responsive" id="header">
                <DataTable
                  // title="Outstanding Transactions"
                  columns={filteredColumns}
                  data={formValues}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  // responsive
                  paginationRowsPerPageOptions={[25, 50, 100, 500]}
                  paginationPerPage={perPageSize}
                  persistTableHead
                  // selectableRows
                  // onSelectedRowsChange={(e) => handleCheckboxChange(e)}
                  sortServer
                  onSort={handleSort}
                  dense
                // contextActions={contextActions}
                // onSelectedRowsChange={handleRowSelected}
                // clearSelectedRows={toggleCleared}
                />
              </div> */}
              <MaterialReactTable
                columns={columns}
                data={data}
                enableColumnResizing
                enableRowActions
                renderRowActionMenuItems={({ row }) => [
                  checkUserPermission("edit-transaction-log") &&
                  row?.original?.Module === "SALES" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/manage-sales/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "RECEIVINGS" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/manage-receiving/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "DEPOSIT" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/bank-deposit/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "TRANSFER" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/manage-transfer/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "JOURNAL" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/journal-entry/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "PAYBILLS" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/receiving-paybills/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : row?.original?.Module === "RECEIVEPAYMENT" ? (
                    <MenuItem
                      onClick={() =>
                        navigate(`/receive-payment/${row.original.ID}`)
                      }
                    >
                      Edit
                    </MenuItem>
                  ) : (
                    ""
                  ),
                ]}
                enableGrouping
                enableStickyHeader
                enableStickyFooter
                enableRowSelection
                enableColumnOrdering
                initialState={{
                  density: "compact",
                  expanded: true, //expand all groups by default
                  // grouping: [""], //an array of columns to group by by default (can be multiple)
                  pagination: { pageIndex: 0, pageSize: 25 },
                  sorting: [{ id: "state", desc: false }], //sort by state by default
                }}
                // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                muiTablePaginationProps={{
                  rowsPerPageOptions: [25, 50, 100, 300, 500],
                }}
                muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                // manualFiltering
                manualPagination
                manualSorting
                muiToolbarAlertBannerProps={
                  isError
                    ? {
                        color: "error",
                        children: "Error loading data",
                      }
                    : undefined
                }
                // onColumnFiltersChange={setColumnFilters}
                onGlobalFilterChange={setGlobalFilter}
                onPaginationChange={setPagination}
                onSortingChange={setSorting}
                rowCount={totalRows}
                state={{
                  // columnFilters,
                  globalFilter,
                  isLoading,
                  pagination,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                  sorting,
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      size="small"
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={handleexcelexport}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Excel
                    </Button>
                    <Button
                      size="small"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleExportRows(table.getSelectedRowModel().rows)
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Excel
                    </Button>
                    <Button
                      size="small"
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={() => downloadPDF("", "allData")}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Pdf
                    </Button>
                    <Button
                      size="small"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        downloadPDF(
                          table.getSelectedRowModel().rows,
                          "selectedRow"
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Pdf
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => onBtPrint()}
                    >
                      Print PDF
                    </Button>
                    {/* <Button
                      size="small"
                      onClick={() =>
                        setPagination({ ...pagination, pageSize: totalRows })
                      }
                      variant="contained"
                    >
                      Get All Data
                    </Button> */}
                  </Box>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentLog;
